// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ../public/css/simple-line-icons.css
// module id = 725
// module chunks = 0